export default __webpack_public_path__ + "static/media/fork_right.1fd47748.svg";